var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightLogoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_54",
    "data-name": "Group 54",
    className: "photon-brand-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.479,
    height: 60,
    viewBox: "0 0 65.479 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-color-scheme: dark) {\n      .photon-brand-logo stop[stop-color=\"#3D0080\"] { stop-color: color-mix(in srgb, #3D0080 60%, white); }\n      .photon-brand-logo stop[stop-color=\"#8B1FCC\"] { stop-color: color-mix(in srgb, #8B1FCC 80%, white); }\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8B1FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F05A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A623"
  })), /*#__PURE__*/React.createElement("path", {
    id: "photon-logo-contour",
    "data-name": "Union 1",
    d: "M48.649,59.959l-.174-.015H12.226A12.207,12.207,0,0,1,1.655,41.634L22.168,6.1A12.427,12.427,0,0,1,24.118,3.55,11.985,11.985,0,0,1,29.487.43,12.416,12.416,0,0,1,32.667,0h.144a12.417,12.417,0,0,1,3.181.43A11.982,11.982,0,0,1,41.362,3.55,12.428,12.428,0,0,1,43.311,6.1l20.514,35.53a12.207,12.207,0,0,1-10.571,18.31H50.667A10.555,10.555,0,0,1,49.579,60C49.27,60,48.957,59.986,48.649,59.959ZM59.67,43.448a11.978,11.978,0,0,1-1.247,11.9A11.729,11.729,0,0,1,57.1,56.892a11.226,11.226,0,0,1-1.535,1.256,10.864,10.864,0,0,1-1.705.947q-.4.178-.82.323h.218A11.681,11.681,0,0,0,63.369,41.9L45.162,10.361Zm-3.875,1.392a11.992,11.992,0,0,1-2.379,11.488,10.578,10.578,0,0,1-2.673,2.2,9.361,9.361,0,0,1-2.1.886h1.989a10.038,10.038,0,0,0,2.111-.458,10.216,10.216,0,0,0,1.973-.9,10.587,10.587,0,0,0,1.769-1.317A11.147,11.147,0,0,0,58,55.037a11.455,11.455,0,0,0,1.193-11.378L45.658,12.8ZM2.11,41.9A11.681,11.681,0,0,0,12.226,59.418H42.461l-30.6-2.677A10.827,10.827,0,0,1,3.041,50.5a11.963,11.963,0,0,1-.434-9.462Zm50.1,3.956a11.772,11.772,0,0,1-3.381,10.973,9.473,9.473,0,0,1-2.45,1.666,8.284,8.284,0,0,1-1.74.588l1.753.153a8.523,8.523,0,0,0,1.819-.244,8.747,8.747,0,0,0,1.741-.632,9.406,9.406,0,0,0,1.618-1.008,10.47,10.47,0,0,0,1.456-1.37A11.462,11.462,0,0,0,55.293,45L45.866,15.2Zm-3.3.678a12.085,12.085,0,0,1-.83,5.825,11.4,11.4,0,0,1-1.415,2.512,10.165,10.165,0,0,1-1.99,2.017,7.887,7.887,0,0,1-3.6,1.567l1.469.266c.146.009.294.014.441.014a7.455,7.455,0,0,0,2.869-.581,8.821,8.821,0,0,0,2.622-1.71,11.243,11.243,0,0,0,3.224-10.481L45.812,17.54ZM4.316,38.858a11.457,11.457,0,0,0-.8,11.413,10.305,10.305,0,0,0,8.4,5.946l26.823,2.347L11.8,53.681a9.207,9.207,0,0,1-4.4-2.1,9.9,9.9,0,0,1-1.667-1.86A11.186,11.186,0,0,1,4.511,47.4a12.049,12.049,0,0,1,.181-9.107Zm41.571,8.055a12.142,12.142,0,0,1-.318,2.926,11.857,11.857,0,0,1-.981,2.689,10.792,10.792,0,0,1-1.563,2.293,9.319,9.319,0,0,1-2.067,1.738,7.444,7.444,0,0,1-1.741.79,6.245,6.245,0,0,1-1.269.244l1.186.336a6.176,6.176,0,0,0,.929.07,7.1,7.1,0,0,0,4.288-1.533,9.645,9.645,0,0,0,1.89-1.917,10.873,10.873,0,0,0,1.348-2.4,11.557,11.557,0,0,0,.792-5.566l-2.858-26.8ZM6.546,36.157A11.494,11.494,0,0,0,5,47.21a10.652,10.652,0,0,0,1.166,2.21,9.385,9.385,0,0,0,1.578,1.762A8.682,8.682,0,0,0,11.9,53.163l23.581,4.275L12,50.78a8.845,8.845,0,0,1-5.956-6.248,11.972,11.972,0,0,1,.715-8.653ZM43.151,47.038a12,12,0,0,1-.555,2.809,11.773,11.773,0,0,1-1.162,2.526,10.3,10.3,0,0,1-1.667,2.076A8.221,8.221,0,0,1,37.694,55.9a5.921,5.921,0,0,1-2.506.626l1.009.4a5.19,5.19,0,0,0,1.26.155,5.606,5.606,0,0,0,1.615-.244,6.907,6.907,0,0,0,1.613-.733,8.8,8.8,0,0,0,1.955-1.645,10.257,10.257,0,0,0,1.485-2.182,11.325,11.325,0,0,0,.934-2.567,11.622,11.622,0,0,0,.3-2.8l-.336-24.983ZM8.768,33.775A11.367,11.367,0,0,0,6.546,44.381a8.328,8.328,0,0,0,5.6,5.892l20.517,5.819-20.25-8.045a8.2,8.2,0,0,1-4.792-6.169,11.79,11.79,0,0,1-.25-2.871A11.974,11.974,0,0,1,7.8,36.195a11.714,11.714,0,0,1,1.008-2.471ZM33.61,55.742A4.432,4.432,0,0,0,35.118,56a5.373,5.373,0,0,0,2.347-.573,7.714,7.714,0,0,0,1.949-1.37,9.768,9.768,0,0,0,1.579-1.971A11.239,11.239,0,0,0,42.1,49.681,11.488,11.488,0,0,0,42.626,47l1.721-23.04-3.66,22.983a12.068,12.068,0,0,1-.754,2.684,11.366,11.366,0,0,1-1.293,2.337A9.512,9.512,0,0,1,36.915,53.8a7.3,7.3,0,0,1-2.051,1.184,5.212,5.212,0,0,1-1.8.337h0q-.133,0-.266-.008ZM31.4,54.416a3.8,3.8,0,0,0,1.67.378,4.675,4.675,0,0,0,1.616-.3A6.788,6.788,0,0,0,36.6,53.384a8.979,8.979,0,0,0,1.627-1.739A10.832,10.832,0,0,0,39.45,49.42a11.559,11.559,0,0,0,.717-2.56l3.347-21.02L38.486,46.658a11.773,11.773,0,0,1-.92,2.511,11.1,11.1,0,0,1-1.4,2.141,8.9,8.9,0,0,1-1.747,1.617,6.282,6.282,0,0,1-1.974.934,4.591,4.591,0,0,1-1.163.155,4.005,4.005,0,0,1-.533-.035ZM8.131,41.768a7.681,7.681,0,0,0,4.471,5.79l17.652,7.013L13,45.492a7.7,7.7,0,0,1-3.777-6.066,11.533,11.533,0,0,1-.014-2.76,12.153,12.153,0,0,1,.619-2.68,11.74,11.74,0,0,1,1.048-2.206A11.224,11.224,0,0,0,8.131,41.768Zm21.4,11.223a3.248,3.248,0,0,0,.833.371,3.39,3.39,0,0,0,.928.127,4.057,4.057,0,0,0,1.026-.137,5.782,5.782,0,0,0,1.824-.867,8.369,8.369,0,0,0,1.64-1.525A10.563,10.563,0,0,0,37.1,48.926a11.274,11.274,0,0,0,.874-2.392l4.581-18.968-6.02,18.65a11.642,11.642,0,0,1-1.051,2.339,10.542,10.542,0,0,1-1.454,1.933A8.085,8.085,0,0,1,32.3,51.88a5.475,5.475,0,0,1-1.883.706,4.063,4.063,0,0,1-.652.054,3.56,3.56,0,0,1-.738-.076ZM11.461,31.836a11.151,11.151,0,0,0-1.139,2.328,11.615,11.615,0,0,0-.591,2.561,11.018,11.018,0,0,0,.013,2.634,7.189,7.189,0,0,0,3.5,5.667l14.985,7.884L13.737,43.119a7.352,7.352,0,0,1-2.889-5.952,11.552,11.552,0,0,1,.2-2.639,12.063,12.063,0,0,1,.771-2.514,11.476,11.476,0,0,1,1.025-1.881A9.9,9.9,0,0,0,11.461,31.836ZM27.991,51.517a2.771,2.771,0,0,0,1.759.6,3.626,3.626,0,0,0,.582-.049,4.977,4.977,0,0,0,1.721-.65,7.551,7.551,0,0,0,1.614-1.305,10.013,10.013,0,0,0,1.371-1.832,11.156,11.156,0,0,0,1-2.224L41.5,29.13,34.825,45.646A11.414,11.414,0,0,1,33.676,47.8a9.947,9.947,0,0,1-1.48,1.725A7.3,7.3,0,0,1,30.509,50.7a4.752,4.752,0,0,1-1.77.506c-.082.006-.166.009-.25.009a3.167,3.167,0,0,1-.894-.124ZM13.516,30.091A10.825,10.825,0,0,0,12.3,32.226a11.523,11.523,0,0,0-.735,2.4,11.031,11.031,0,0,0-.188,2.518,6.837,6.837,0,0,0,2.657,5.538l12.527,8.464L14.593,40.929a7.122,7.122,0,0,1-2.1-5.837,11.533,11.533,0,0,1,.337-2.284,11.963,11.963,0,0,1,.768-2.158,11.291,11.291,0,0,1,1.143-1.926A9.433,9.433,0,0,0,13.516,30.091Zm13.2,19.893a2.4,2.4,0,0,0,.791.526,2.588,2.588,0,0,0,.974.181c.071,0,.145,0,.218-.008a4.257,4.257,0,0,0,1.6-.462,6.774,6.774,0,0,0,1.561-1.1,9.427,9.427,0,0,0,1.39-1.63,10.932,10.932,0,0,0,1.087-2.042l6.031-14.926-7.03,14.449a11.085,11.085,0,0,1-1.2,1.938,9.362,9.362,0,0,1-1.461,1.514,6.642,6.642,0,0,1-1.6.989,4.19,4.19,0,0,1-1.63.357h-.068a2.882,2.882,0,0,1-.8-.126q-.075-.023-.148-.051Zm-11.207-21.4a10.431,10.431,0,0,0-1.269,1.931,11.386,11.386,0,0,0-.856,2.222,11.049,11.049,0,0,0-.373,2.376,6.609,6.609,0,0,0,1.92,5.413l10.278,8.777L15.54,38.922a4.924,4.924,0,0,1-.775-1.117,6.223,6.223,0,0,1-.5-1.361,7.95,7.95,0,0,1-.212-1.552,9.835,9.835,0,0,1,.083-1.695,11.521,11.521,0,0,1,.468-2.044,11.825,11.825,0,0,1,.813-1.907,11.036,11.036,0,0,1,1.108-1.686l.019-.024A8.93,8.93,0,0,0,15.513,28.588Zm10.2,19.851a2.111,2.111,0,0,0,.726.588,2.266,2.266,0,0,0,.949.217h.053a3.711,3.711,0,0,0,1.453-.323A6.122,6.122,0,0,0,30.365,48a8.839,8.839,0,0,0,1.366-1.425,10.608,10.608,0,0,0,1.133-1.836l6.327-13L32.06,44.217a10.674,10.674,0,0,1-1.178,1.673,8.9,8.9,0,0,1-1.366,1.292,6.288,6.288,0,0,1-1.454.836,3.933,3.933,0,0,1-1.446.3A3.041,3.041,0,0,1,26.3,48.3a2.517,2.517,0,0,1-.7-.175l-.091-.04ZM24.934,46.9a1.836,1.836,0,0,0,1.417.88,2.553,2.553,0,0,0,.27.014,3.432,3.432,0,0,0,1.275-.27,5.76,5.76,0,0,0,1.328-.774,8.387,8.387,0,0,0,1.271-1.212A10.228,10.228,0,0,0,31.6,43.956l6.39-11.181L30.976,43.4a10.178,10.178,0,0,1-1.136,1.429,8.418,8.418,0,0,1-1.267,1.093,5.949,5.949,0,0,1-1.316.7,3.716,3.716,0,0,1-1.285.249,2.69,2.69,0,0,1-.511-.048,2.2,2.2,0,0,1-.661-.238Zm-7.5-19.586a9.972,9.972,0,0,0-1.294,1.719,11.2,11.2,0,0,0-.951,2.026,11.037,11.037,0,0,0-.534,2.21,9.329,9.329,0,0,0-.079,1.593,7.437,7.437,0,0,0,.194,1.445,5.705,5.705,0,0,0,.453,1.25,4.4,4.4,0,0,0,.7,1.009l8.244,8.85L16.554,37.094a4.717,4.717,0,0,1-.611-1.137,6.154,6.154,0,0,1-.333-1.348,8.006,8.006,0,0,1-.053-1.509,9.975,9.975,0,0,1,.231-1.623,11.456,11.456,0,0,1,.576-1.824,11.615,11.615,0,0,1,.853-1.68,10.713,10.713,0,0,1,1.046-1.426A8.393,8.393,0,0,0,17.439,27.311ZM24.366,45.38a1.614,1.614,0,0,0,1.195.933,2.228,2.228,0,0,0,.419.039,3.2,3.2,0,0,0,1.122-.224,5.419,5.419,0,0,0,1.194-.646,7.913,7.913,0,0,0,1.175-1.022,9.743,9.743,0,0,0,1.066-1.345l6.258-9.48-6.724,8.915a8.812,8.812,0,0,1-2.245,2.123,4.463,4.463,0,0,1-2.328.789,2.456,2.456,0,0,1-.654-.085,1.974,1.974,0,0,1-.56-.251ZM19.281,26.246a9.432,9.432,0,0,0-1.291,1.5A11.042,11.042,0,0,0,16.3,31.591a9.462,9.462,0,0,0-.218,1.526,7.487,7.487,0,0,0,.046,1.4,5.635,5.635,0,0,0,.3,1.237,4.2,4.2,0,0,0,.547,1.023l6.428,8.711-5.793-10.05a4.594,4.594,0,0,1-.462-1.153,6.151,6.151,0,0,1-.183-1.334,8.113,8.113,0,0,1,.094-1.468,10.145,10.145,0,0,1,.369-1.556,11.6,11.6,0,0,1,.654-1.613,11.179,11.179,0,0,1,.863-1.455,10.109,10.109,0,0,1,.873-1.08Q19.546,26,19.281,26.246Zm4.7,17.652a1.444,1.444,0,0,0,1,.971,1.96,1.96,0,0,0,.523.068,3.013,3.013,0,0,0,.987-.184,5.1,5.1,0,0,0,1.07-.535,8.346,8.346,0,0,0,2.084-1.986l5.97-7.916-6.29,7.353a9.265,9.265,0,0,1-1.011,1.015,7.356,7.356,0,0,1-1.056.759,5.205,5.205,0,0,1-1.054.478,3.363,3.363,0,0,1-1.007.167,2.3,2.3,0,0,1-.784-.131,1.789,1.789,0,0,1-.477-.258ZM19.758,26.659a10.777,10.777,0,0,0-1.826,3.433,9.64,9.64,0,0,0-.349,1.463,7.586,7.586,0,0,0-.091,1.367,5.629,5.629,0,0,0,.164,1.223,4.085,4.085,0,0,0,.412,1.035L22.9,43.562l-4.2-9.6a4.555,4.555,0,0,1-.326-1.166,6.2,6.2,0,0,1-.044-1.318,8.228,8.228,0,0,1,.231-1.426,10.294,10.294,0,0,1,.5-1.488,11.33,11.33,0,0,1,.7-1.4,10.784,10.784,0,0,1,.862-1.243,9.728,9.728,0,0,1,.716-.8A8.354,8.354,0,0,0,19.758,26.659Zm4,15.81a1.31,1.31,0,0,0,.836.994,1.743,1.743,0,0,0,.594.1,3.725,3.725,0,0,0,1.823-.587,7.788,7.788,0,0,0,1.916-1.645l5.557-6.5-5.749,5.948a8.579,8.579,0,0,1-.932.836,6.846,6.846,0,0,1-.955.621,4.919,4.919,0,0,1-.941.388,3.231,3.231,0,0,1-.89.135,2.1,2.1,0,0,1-.866-.174,1.632,1.632,0,0,1-.408-.259Zm-.08-1.387a1.5,1.5,0,0,0,.228.638,1.08,1.08,0,0,0,.461.387,1.558,1.558,0,0,0,.641.126,3.535,3.535,0,0,0,1.609-.474,7.207,7.207,0,0,0,1.74-1.344l5.056-5.231-5.135,4.709a7.9,7.9,0,0,1-.847.678,6.353,6.353,0,0,1-.855.5,4.652,4.652,0,0,1-.834.311,3.129,3.129,0,0,1-.784.108,1.942,1.942,0,0,1-.93-.216,1.516,1.516,0,0,1-.35-.258ZM21.456,25.767a10.4,10.4,0,0,0-1.911,3,9.8,9.8,0,0,0-.472,1.4,7.716,7.716,0,0,0-.218,1.328,5.68,5.68,0,0,0,.036,1.209,4.046,4.046,0,0,0,.29,1.045l3.455,7.894-2.841-9a4.564,4.564,0,0,1-.2-1.173,6.271,6.271,0,0,1,.086-1.3,8.351,8.351,0,0,1,.359-1.379,10.425,10.425,0,0,1,.622-1.417,10.906,10.906,0,0,1,.724-1.182,10.271,10.271,0,0,1,.84-1.042q.245-.266.5-.506A7.888,7.888,0,0,0,21.456,25.767Zm2.269,14.014a1.454,1.454,0,0,0,.159.633.965.965,0,0,0,.4.4,1.466,1.466,0,0,0,.69.152,2.613,2.613,0,0,0,.614-.079,3.906,3.906,0,0,0,.713-.254,6.484,6.484,0,0,0,1.628-1.123l4.49-4.117-4.472,3.63a4.994,4.994,0,0,1-2.933,1.263,1.812,1.812,0,0,1-.984-.258,1.4,1.4,0,0,1-.3-.253Zm-.662-14.728a9.878,9.878,0,0,0-1.936,2.569,9.672,9.672,0,0,0-.58,1.326,7.983,7.983,0,0,0-.337,1.292,5.9,5.9,0,0,0-.085,1.2,3.982,3.982,0,0,0,.172,1.047l2.3,7.272-1.706-8.274a4.555,4.555,0,0,1-.083-1.105,6.25,6.25,0,0,1,.166-1.167,8.179,8.179,0,0,1,.381-1.186,9.767,9.767,0,0,1,.565-1.164,10.463,10.463,0,0,1,.72-1.1,9.979,9.979,0,0,1,.846-.989q.21-.215.428-.41A7.535,7.535,0,0,0,23.063,25.053Zm.9,14.125a.874.874,0,0,0,.34.4,1.345,1.345,0,0,0,.716.176,2.509,2.509,0,0,0,.535-.062,3.668,3.668,0,0,0,.621-.2,5.93,5.93,0,0,0,1.432-.884L31.5,35.454l-3.789,2.712a6.01,6.01,0,0,1-1.326.731,3.434,3.434,0,0,1-1.223.253,2.034,2.034,0,0,1-.562-.075,1.521,1.521,0,0,1-.479-.231,1.328,1.328,0,0,1-.253-.241A1.38,1.38,0,0,0,23.967,39.178Zm.176-1.162a.8.8,0,0,0,.289.4,1.206,1.206,0,0,0,.725.2,4.172,4.172,0,0,0,2.247-.883l3.276-2.345L27.573,37.34a5.448,5.448,0,0,1-1.142.552,3.311,3.311,0,0,1-1.05.19A1.977,1.977,0,0,1,24.79,38a1.412,1.412,0,0,1-.489-.262,1.227,1.227,0,0,1-.21-.226A1.3,1.3,0,0,0,24.143,38.016Zm.411-13.5a9.352,9.352,0,0,0-1.822,2.054,9.182,9.182,0,0,0-1.164,2.467,6.091,6.091,0,0,0-.228,1.219,4.036,4.036,0,0,0,.06,1.118l1.349,6.545-.79-7.452a4.55,4.55,0,0,1,.016-1.044,6.229,6.229,0,0,1,.241-1.083,8.058,8.058,0,0,1,.433-1.085,9.49,9.49,0,0,1,.595-1.051,10.03,10.03,0,0,1,.727-.979,9.45,9.45,0,0,1,.831-.87q.1-.094.207-.184Q24.782,24.334,24.555,24.52Zm7.025-.326a3.744,3.744,0,0,0-.6.2,5.357,5.357,0,0,0-.92.5,6.188,6.188,0,0,0-.835.672,5.622,5.622,0,0,0-.682.781,4,4,0,0,0-.462.822L24.565,35.84l-.159.493a1.359,1.359,0,0,0-.01.6.737.737,0,0,0,.244.4.911.911,0,0,0,.32.169,1.443,1.443,0,0,0,.425.059,3.819,3.819,0,0,0,1.91-.666l9.748-6.108a6.218,6.218,0,0,0,1.044-.818,5.245,5.245,0,0,0,.733-.886,3.652,3.652,0,0,0,.418-.85,1.846,1.846,0,0,0,.1-.7.746.746,0,0,0-.479-.684l-6.215-2.623a1.362,1.362,0,0,0-.533-.1A2.428,2.428,0,0,0,31.579,24.194ZM22.624,6.366l-.028.048L5.036,36.829,25.3,6.425h0a11.8,11.8,0,0,1,1.716-1.995,11.014,11.014,0,0,1,2.17-1.57,10.534,10.534,0,0,1,5.1-1.309c.313,0,.631.014.945.041a10.721,10.721,0,0,1,2.354.474,10.528,10.528,0,0,1,2.146.969,10.636,10.636,0,0,1,1.27.888A11.7,11.7,0,0,0,22.624,6.366ZM25.871,24.18a8.727,8.727,0,0,0-1.8,1.8,8.942,8.942,0,0,0-1.246,2.241,6.073,6.073,0,0,0-.3,1.135,4.04,4.04,0,0,0-.038,1.062l.609,5.738L23.008,29.6a4.557,4.557,0,0,1,.1-.98,6.182,6.182,0,0,1,.3-1,7.877,7.877,0,0,1,.473-.987,9.152,9.152,0,0,1,.614-.944,9.531,9.531,0,0,1,.726-.868,8.873,8.873,0,0,1,.766-.722ZM25.3,25.54a8.613,8.613,0,0,0-1.286,2.011,6.016,6.016,0,0,0-.362,1.043,4.05,4.05,0,0,0-.121,1l.063,4.878.423-5.617a4.57,4.57,0,0,1,.168-.912,6.114,6.114,0,0,1,.348-.915,7.661,7.661,0,0,1,.5-.892,8.757,8.757,0,0,1,.62-.841,8.975,8.975,0,0,1,.714-.763q.192-.183.392-.35A8.384,8.384,0,0,0,25.3,25.54ZM31.766,2.4a10.066,10.066,0,0,0-2.332.927,10.49,10.49,0,0,0-2.067,1.5A11.292,11.292,0,0,0,25.65,6.842L7.756,33.7,28,7.092h0a11.119,11.119,0,0,1,1.542-1.615A10.1,10.1,0,0,1,31.423,4.2a9.394,9.394,0,0,1,2.07-.786,9.088,9.088,0,0,1,2.189-.268,9.221,9.221,0,0,1,5.443,1.778,9.54,9.54,0,0,1,.925.771,10.367,10.367,0,0,0-1.83-1.7A10.014,10.014,0,0,0,37.85,2.721a10.142,10.142,0,0,0-2.673-.6c-.3-.026-.6-.039-.9-.039A10.05,10.05,0,0,0,31.766,2.4ZM26.444,25.219a8.232,8.232,0,0,0-1.3,1.792,5.912,5.912,0,0,0-.406.952,4.045,4.045,0,0,0-.189.926l-.3,3.994.744-4.659a5.173,5.173,0,0,1,.61-1.68,7.374,7.374,0,0,1,.517-.8A8.307,8.307,0,0,1,26.737,25a8.408,8.408,0,0,1,.7-.665l.027-.022A8.068,8.068,0,0,0,26.444,25.219Zm.99-.161a7.756,7.756,0,0,0-1.265,1.563,5.714,5.714,0,0,0-.425.847,4.01,4.01,0,0,0-.237.839l-.5,3.1.9-3.7a5.086,5.086,0,0,1,.68-1.532,7.052,7.052,0,0,1,.525-.714,7.816,7.816,0,0,1,.614-.654q.1-.091.194-.179C27.756,24.764,27.592,24.907,27.434,25.059ZM33.618,3.929a8.874,8.874,0,0,0-1.956.743,9.577,9.577,0,0,0-1.785,1.208A10.62,10.62,0,0,0,28.324,7.53L10.487,30.975,30.265,8.048a10.433,10.433,0,0,1,1.467-1.4,9.259,9.259,0,0,1,1.632-1.025,8.4,8.4,0,0,1,1.748-.629,7.81,7.81,0,0,1,3.781.038,8.061,8.061,0,0,1,1.774.692A8.188,8.188,0,0,1,42.217,6.8a8.582,8.582,0,0,1,.656.644,9.425,9.425,0,0,0-1.405-1.562,8.808,8.808,0,0,0-2-1.335,8.717,8.717,0,0,0-3.789-.871A8.561,8.561,0,0,0,33.618,3.929Zm-6.5,22.409a5.472,5.472,0,0,0-.428.743,3.953,3.953,0,0,0-.269.75l-.541,2.236.9-2.777a4.965,4.965,0,0,1,.729-1.387,6.694,6.694,0,0,1,.525-.631q.082-.088.169-.173A7.2,7.2,0,0,0,27.117,26.339Zm.872-.2a5.215,5.215,0,0,0-.422.647,3.871,3.871,0,0,0-.29.663l-.456,1.411.769-1.9a4.5,4.5,0,0,1,.517-.922,5.886,5.886,0,0,1,.38-.476A6.343,6.343,0,0,0,27.989,26.143ZM13.183,28.656,32.312,9.024a9.677,9.677,0,0,1,1.3-1.122,8.478,8.478,0,0,1,1.407-.816,7.547,7.547,0,0,1,1.476-.5,6.925,6.925,0,0,1,1.509-.169,6.679,6.679,0,0,1,2.189.369,7.078,7.078,0,0,1,1.536.75,7.319,7.319,0,0,1,1.311,1.09q.234.245.449.515a8.634,8.634,0,0,0-1.069-1.413,7.814,7.814,0,0,0-1.673-1.358,7.518,7.518,0,0,0-1.988-.835A7.283,7.283,0,0,0,35.23,5.5a7.88,7.88,0,0,0-1.641.591,8.738,8.738,0,0,0-1.537.967,9.893,9.893,0,0,0-1.388,1.329l-.1.114h0Zm25.881-2.291a1.251,1.251,0,0,1,.774.94,1.612,1.612,0,0,0,0-.479.818.818,0,0,0-.616-.7l-2.648-.809ZM36.608,7.1a7.028,7.028,0,0,0-1.375.465,7.958,7.958,0,0,0-1.318.765,9.142,9.142,0,0,0-1.221,1.051l-.006.006L15.806,26.718,34.067,10.107A8.4,8.4,0,0,1,36.41,8.572a6.277,6.277,0,0,1,2.469-.522,5.815,5.815,0,0,1,2.328.489,6.089,6.089,0,0,1,1.333.8,6.679,6.679,0,0,1,1.112,1.114q.179.226.342.47a8.018,8.018,0,0,0-.836-1.348,7.007,7.007,0,0,0-1.406-1.38,6.545,6.545,0,0,0-1.728-.906,6.147,6.147,0,0,0-2.015-.339A6.408,6.408,0,0,0,36.608,7.1Zm2.77,18.517a1.408,1.408,0,0,1,.661.412,1.379,1.379,0,0,1,.312.659,1.781,1.781,0,0,0-.02-.645.936.936,0,0,0-.267-.473,1.035,1.035,0,0,0-.51-.246l-3.309-.666Zm.279-.808a1.554,1.554,0,0,1,.769.377,1.454,1.454,0,0,1,.415.731q.011.044.02.089a1.958,1.958,0,0,0-.058-.816,1.014,1.014,0,0,0-.346-.5,1.218,1.218,0,0,0-.619-.226L35.8,24.036Zm.235-.872a1.736,1.736,0,0,1,.89.333,1.532,1.532,0,0,1,.52.755,2.035,2.035,0,0,1,.066.255,2.2,2.2,0,0,0-.119-1.021,1.114,1.114,0,0,0-.441-.535,1.438,1.438,0,0,0-.745-.2l-4.824-.084ZM36.608,9.06A7.863,7.863,0,0,0,34.422,10.5l-.111.1L18.324,25.14,35.553,11.27a7.675,7.675,0,0,1,2.013-1.189,5.661,5.661,0,0,1,2.059-.4,5,5,0,0,1,2.347.583,5.428,5.428,0,0,1,1.144.808,6.049,6.049,0,0,1,.927,1.085q.082.122.159.249a7.564,7.564,0,0,0-.582-1.094,6.443,6.443,0,0,0-1.162-1.358A5.6,5.6,0,0,0,41,9.022a5.288,5.288,0,0,0-2.117-.444A5.767,5.767,0,0,0,36.608,9.06ZM40.22,22.533l-5.679.377,5.532.1a1.954,1.954,0,0,1,1.024.278,1.632,1.632,0,0,1,.639.777,2.18,2.18,0,0,1,.121.4,2.407,2.407,0,0,0-.2-1.208,1.25,1.25,0,0,0-.5-.54,1.566,1.566,0,0,0-.783-.185C40.328,22.527,40.277,22.529,40.22,22.533ZM35.882,11.68,20.711,23.893l15.955-11.32.123-.087,0,0,.118-.084h0a6.888,6.888,0,0,1,1.585-.816,5.138,5.138,0,0,1,1.706-.3,4.347,4.347,0,0,1,2.319.662,4.872,4.872,0,0,1,.979.805,5.514,5.514,0,0,1,.768,1.047q.039.068.076.138a7,7,0,0,0-.423-.958,5.836,5.836,0,0,0-.952-1.313,4.949,4.949,0,0,0-1.243-.934,4.475,4.475,0,0,0-2.1-.521A6.038,6.038,0,0,0,35.882,11.68Zm6.249,11.338a2.433,2.433,0,0,1,.206.6q0-.019,0-.037a3.224,3.224,0,0,0-.065-.778,2.151,2.151,0,0,0-.245-.642,1.414,1.414,0,0,0-.551-.539,1.683,1.683,0,0,0-.8-.183,2.653,2.653,0,0,0-.382.029l-.149.022-6.447.945L40.335,22v0h.038A1.856,1.856,0,0,1,42.131,23.017ZM38.665,12.083a6.446,6.446,0,0,0-1.571.831L22.954,22.947,37.8,13.732l.007,0,.121-.075h0a6.214,6.214,0,0,1,1.3-.589,4.686,4.686,0,0,1,1.4-.224,3.892,3.892,0,0,1,1.186.182,3.816,3.816,0,0,1,1.075.546,4.289,4.289,0,0,1,.841.809,5.131,5.131,0,0,1,.632,1.035l.034.075a6.58,6.58,0,0,0-.3-.868,5.357,5.357,0,0,0-.778-1.288,4.408,4.408,0,0,0-1.072-.943,3.822,3.822,0,0,0-2.041-.581A4.624,4.624,0,0,0,38.665,12.083Zm3.063,9.082a1.926,1.926,0,0,1,.753.73,2.616,2.616,0,0,1,.3.758q0-.057,0-.113a3.465,3.465,0,0,0-.12-.855,2.307,2.307,0,0,0-.316-.691,1.618,1.618,0,0,0-.606-.537,1.828,1.828,0,0,0-.828-.181,2.938,2.938,0,0,0-.637.075h0l-7.572,1.7,7.521-1.1a3.116,3.116,0,0,1,.451-.034A2.222,2.222,0,0,1,41.728,21.165Zm-2.351-7.594a5.767,5.767,0,0,0-1.3.608l-13.049,8.1L38.6,14.99a5.669,5.669,0,0,1,1.173-.477,4.294,4.294,0,0,1,1.136-.16,3.483,3.483,0,0,1,1.166.2,3.336,3.336,0,0,1,1.024.586,3.9,3.9,0,0,1,.706.776,4.65,4.65,0,0,1,.471.871,6.2,6.2,0,0,0-.193-.667,4.983,4.983,0,0,0-.617-1.215,3.843,3.843,0,0,0-.885-.906,3.279,3.279,0,0,0-.927-.47,3.379,3.379,0,0,0-1.027-.156A4.173,4.173,0,0,0,39.377,13.571Zm.538,1.446a5.273,5.273,0,0,0-1.06.435l-.138.074L26.925,21.858l12.293-5.614.006,0,.131-.06v0a4.393,4.393,0,0,1,1.718-.383,3.067,3.067,0,0,1,1.134.21,2.989,2.989,0,0,1,.968.626,3.579,3.579,0,0,1,.591.745,4.253,4.253,0,0,1,.346.73q-.05-.289-.126-.559A4.575,4.575,0,0,0,43.5,16.41a3.462,3.462,0,0,0-.74-.871,2.866,2.866,0,0,0-.867-.5,2.9,2.9,0,0,0-.983-.167A3.714,3.714,0,0,0,39.915,15.016Zm.212,4.166-8.6,2.595,8.629-1.938a3.415,3.415,0,0,1,.745-.087,2.378,2.378,0,0,1,1.073.239,2.123,2.123,0,0,1,.8.705,2.829,2.829,0,0,1,.406.916q0-.1-.011-.189a3.748,3.748,0,0,0-.186-.936,2.5,2.5,0,0,0-.4-.741,1.831,1.831,0,0,0-.669-.531,2.063,2.063,0,0,0-.87-.18A3.192,3.192,0,0,0,40.127,19.182Zm-.69-2.46L28.644,21.651,39.67,17.476a4.1,4.1,0,0,1,1.443-.287,2.792,2.792,0,0,1,1.11.22,2.646,2.646,0,0,1,.911.655,3.445,3.445,0,0,1,.72,1.281q-.026-.211-.067-.411a4.3,4.3,0,0,0-.367-1.083,3.059,3.059,0,0,0-.609-.835,2.45,2.45,0,0,0-.8-.516,2.565,2.565,0,0,0-.944-.173A3.958,3.958,0,0,0,39.437,16.722Zm.419,1.247-.046.017-9.636,3.648,9.657-2.913.288-.087v0a3.641,3.641,0,0,1,.93-.129,2.4,2.4,0,0,1,1.945.91,3.151,3.151,0,0,1,.555,1.11q-.013-.163-.035-.319a3.969,3.969,0,0,0-.272-1,2.792,2.792,0,0,0-.5-.789,2.112,2.112,0,0,0-.732-.525,2.289,2.289,0,0,0-.9-.177A3.561,3.561,0,0,0,39.856,17.968Z",
    fill: "url(#linear-gradient)",
    "data-photon-outline": ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-photon-particles": "",
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.36,
    cy: 0.72,
    r: 0.59,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.58,
    cy: 0.9,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.37,
    cy: 0.68,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.97,
    cy: 2.85,
    r: 0.41,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.3,
    cy: 2.63,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.16,
    cy: 4.85,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.1,
    cy: 4.52,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.92,
    cy: 5.01,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.01,
    cy: 6.81,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.35,
    cy: 7,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.23,
    cy: 7.01,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.74,
    cy: 6.58,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.25,
    cy: 7.03,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.65,
    cy: 6.66,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.1,
    cy: 8.82,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.34,
    cy: 9,
    r: 0.52,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.78,
    cy: 8.48,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.58,
    cy: 8.48,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.89,
    cy: 9.04,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.71,
    cy: 8.99,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.73,
    cy: 10.79,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.98,
    cy: 11.18,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.52,
    cy: 10.86,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.3,
    cy: 10.67,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.52,
    cy: 10.66,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.99,
    cy: 13.05,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.27,
    cy: 12.99,
    r: 0.58,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.47,
    cy: 13.09,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.12,
    cy: 13.11,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.92,
    cy: 12.87,
    r: 0.56,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.88,
    cy: 13.11,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.36,
    cy: 14.63,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.22,
    cy: 14.98,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.84,
    cy: 14.92,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.94,
    cy: 16.83,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.95,
    cy: 16.7,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.21,
    cy: 16.78,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.73,
    cy: 16.8,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.79,
    cy: 17.11,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.42,
    cy: 17.15,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.51,
    cy: 17.18,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.61,
    cy: 16.82,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.53,
    cy: 17.15,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.44,
    cy: 18.83,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.44,
    cy: 19.03,
    r: 0.59,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.44,
    cy: 19.2,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 19.36,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.66,
    cy: 19.32,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.66,
    cy: 18.96,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.48,
    cy: 19.26,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.22,
    cy: 21.3,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.14,
    cy: 20.89,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.07,
    cy: 21.32,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.31,
    cy: 20.83,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.51,
    cy: 20.84,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.58,
    cy: 21.15,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.67,
    cy: 21.35,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.28,
    cy: 21.38,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.53,
    cy: 21.05,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.39,
    cy: 20.78,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.24,
    cy: 21.37,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.33,
    cy: 21.38,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.41,
    cy: 21.39,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.83,
    cy: 20.95,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.24,
    cy: 23.07,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.91,
    cy: 23.17,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.29,
    cy: 23.08,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.09,
    cy: 23.15,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.17,
    cy: 23.03,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.98,
    cy: 22.98,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.52,
    cy: 23.09,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.07,
    cy: 23.04,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.63,
    cy: 23.1,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.08,
    cy: 22.81,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.42,
    cy: 23.28,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.81,
    cy: 22.89,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.98,
    cy: 23.09,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.78,
    cy: 23.44,
    r: 0.48,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.67,
    cy: 23,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.62,
    cy: 23.43,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.99,
    cy: 23.39,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.62,
    cy: 24.98,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.11,
    cy: 25.37,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8,
    cy: 25.01,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.17,
    cy: 25.08,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.17,
    cy: 25.11,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.07,
    cy: 24.95,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.57,
    cy: 25.4,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.8,
    cy: 25.11,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.39,
    cy: 25.29,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.27,
    cy: 25.17,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.84,
    cy: 25.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.85,
    cy: 25.42,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.61,
    cy: 24.95,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.18,
    cy: 27.29,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.21,
    cy: 27.09,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.22,
    cy: 27.2,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.73,
    cy: 27.59,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.09,
    cy: 27.2,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.41,
    cy: 27.57,
    r: 0.43,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.85,
    cy: 27.2,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 27.04,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.91,
    cy: 27.19,
    r: 0.58,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.97,
    cy: 27,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.65,
    cy: 29.05,
    r: 0.51,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.96,
    cy: 29.54,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.65,
    cy: 29.42,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.1,
    cy: 29.05,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.08,
    cy: 29.57,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.58,
    cy: 29.42,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.62,
    cy: 29.42,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.91,
    cy: 31.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.63,
    cy: 31.64,
    r: 0.46,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.82,
    cy: 31.37,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.11,
    cy: 31.38,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.94,
    cy: 31.05,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.65,
    cy: 31.39,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.58,
    cy: 31.53,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.85,
    cy: 31.38,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.03,
    cy: 31.28,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 33.14,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.67,
    cy: 33.42,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.79,
    cy: 33.74,
    r: 0.47,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.49,
    cy: 33.56,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.02,
    cy: 33.43,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.35,
    cy: 33.27,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.44,
    cy: 33.75,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.55,
    cy: 33.51,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.36,
    cy: 33.19,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.54,
    cy: 33.74,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.73,
    cy: 33.64,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.07,
    cy: 33.14,
    r: 0.57,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.73,
    cy: 33.4,
    r: 0.53,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.12,
    cy: 35.71,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.12,
    cy: 35.71,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.18,
    cy: 35.55,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.08,
    cy: 35.58,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.19,
    cy: 35.24,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.1,
    cy: 35.4,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.07,
    cy: 35.78,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.11,
    cy: 35.18,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.38,
    cy: 35.34,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.87,
    cy: 35.55,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.68,
    cy: 35.27,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.46,
    cy: 37.29,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.13,
    cy: 37.19,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 37.8,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.84,
    cy: 37.79,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.45,
    cy: 37.59,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.62,
    cy: 37.83,
    r: 0.42,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.35,
    cy: 37.25,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.07,
    cy: 37.72,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.56,
    cy: 37.46,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4,
    cy: 37.6,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.6,
    cy: 37.76,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.63,
    cy: 37.18,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.48,
    cy: 37.85,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.09,
    cy: 37.78,
    r: 0.4,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.09,
    cy: 37.62,
    r: 0.42,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.81,
    cy: 39.71,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.3,
    cy: 39.44,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.17,
    cy: 39.56,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.36,
    cy: 39.72,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.21,
    cy: 39.44,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.07,
    cy: 39.56,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.63,
    cy: 39.28,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.51,
    cy: 39.78,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.2,
    cy: 39.7,
    r: 0.47,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.59,
    cy: 39.85,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.56,
    cy: 41.64,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.81,
    cy: 41.37,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.98,
    cy: 41.51,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.11,
    cy: 41.34,
    r: 0.43,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.62,
    cy: 41.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.59,
    cy: 41.35,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.26,
    cy: 41.87,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.33,
    cy: 41.54,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.48,
    cy: 41.43,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.99,
    cy: 41.32,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.92,
    cy: 43.35,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.33,
    cy: 43.74,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.35,
    cy: 43.6,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.88,
    cy: 43.55,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.61,
    cy: 43.64,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.15,
    cy: 43.59,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.67,
    cy: 43.78,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.09,
    cy: 43.69,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.28,
    cy: 43.44,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.67,
    cy: 45.99,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 46.04,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.26,
    cy: 45.66,
    r: 0.58,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.6,
    cy: 45.99,
    r: 0.52,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 45.4,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.73,
    cy: 45.41,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.93,
    cy: 45.38,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.95,
    cy: 47.4,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.91,
    cy: 47.64,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8,
    cy: 48,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.27,
    cy: 48.07,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4,
    cy: 47.92,
    r: 0.49,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.36,
    cy: 47.99,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.43,
    cy: 47.99,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.87,
    cy: 47.67,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.04,
    cy: 48.09,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.48,
    cy: 49.8,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.95,
    cy: 49.63,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.66,
    cy: 49.89,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.05,
    cy: 49.79,
    r: 0.44,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.12,
    cy: 49.83,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.15,
    cy: 49.62,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4,
    cy: 49.87,
    r: 0.56,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.24,
    cy: 49.54,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.63,
    cy: 49.64,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.36,
    cy: 49.8,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.02,
    cy: 50.02,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.27,
    cy: 49.72,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.98,
    cy: 51.88,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.56,
    cy: 52.12,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.38,
    cy: 51.69,
    r: 0.43,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.35,
    cy: 51.96,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.4,
    cy: 53.61,
    r: 0.44,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.19,
    cy: 53.67,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.06,
    cy: 53.84,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.67,
    cy: 54.09,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.1,
    cy: 53.77,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.13,
    cy: 53.6,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.35,
    cy: 54.03,
    r: 0.45,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.84,
    cy: 53.68,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.35,
    cy: 53.68,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.65,
    cy: 55.91,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1,
    cy: 56,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.14,
    cy: 55.9,
    r: 0.57,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.51,
    cy: 55.71,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.43,
    cy: 56.17,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.09,
    cy: 56.28,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.11,
    cy: 56.07,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.14,
    cy: 56.26,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.64,
    cy: 56.22,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.34,
    cy: 56.18,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.23,
    cy: 57.9,
    r: 0.52,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.18,
    cy: 57.82,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.31,
    cy: 58.24,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.46,
    cy: 58.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.77,
    cy: 58.21,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.64,
    cy: 57.89,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.09,
    cy: 57.73,
    r: 0.5,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.86,
    cy: 59.71,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.21,
    cy: 59.74,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.44,
    cy: 59.75,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.46,
    cy: 59.71,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.55,
    cy: 59.75,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.78,
    cy: 59.78,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.02,
    cy: 59.72,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.06,
    cy: 59.87,
    r: 0.85
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightLogoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/light_logo_icon.e264c0a4e01a84307e3c2ed9bec8c54d.svg";